import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import isElectron from 'is-electron';
import appConfig from 'app-config';
import { getQueryParam, setAdminLocationToStorage } from 'flow/utils/browser-utils';
import { jsx as _jsx } from "react/jsx-runtime";
var saveAdminLocationToStorage = function saveAdminLocationToStorage(apiHost) {
  if (apiHost) {
    setAdminLocationToStorage(apiHost);
  }
};

/**
 * This is a Higher Order Component that wraps other components.
 * Its function is to remember which domain the admin pages are located at for
 * this webapp, whether it's home.telavox.se or some cloud partners own domain,
 * like hem.tele10.se.
 *
 * @param WrappedComponent
 */
export function setAdminLocation(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    function Wrapper(props) {
      var _this;
      _classCallCheck(this, Wrapper);
      _this = _callSuper(this, Wrapper, [props]);
      var location = _this.props.location;
      if (!isElectron() && appConfig.production) {
        var hostParam = getQueryParam(location.search, 'host');
        if (hostParam) {
          saveAdminLocationToStorage(hostParam);
        }
      }
      return _this;
    }
    _inherits(Wrapper, _React$Component);
    return _createClass(Wrapper, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, this.props));
      }
    }]);
  }(React.Component);
}